import { render, staticRenderFns } from "./Cabecalho.vue?vue&type=template&id=524279bd&scoped=true&"
import script from "./Cabecalho.vue?vue&type=script&lang=js&"
export * from "./Cabecalho.vue?vue&type=script&lang=js&"
import style0 from "./Cabecalho.vue?vue&type=style&index=0&id=524279bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524279bd",
  null
  
)

export default component.exports